import { Data, QueryParams } from 'lib/components/datatable/DataTable.vue.d';
import { ToastMessageOptions } from 'lib/components/toast/Toast.vue.d';

import mitt, { Emitter } from './mitt';

export type TableEvent = {
  tableName?: string;
};

type PredefinedEvents = {
  'data-table:apply-filter': TableEvent & {
    filter: QueryParams;
  };
  'search-table': TableEvent & {
    search: string | undefined;
  };
  'search-by-scan-table': TableEvent & {
    tag?: string;
  };
  'show-filter': TableEvent & {
    show: boolean;
  };
  'multi-select:hide-overlay': unknown;
  'button-download:multi-tables': {
    table: {
      headers: string[];
      data: Record<string, unknown>[];
      tableName: string;
      tableTitle?: string;
    };
  };
  'data-table:update': TableEvent;
  'data-table:updated': TableEvent & {
    data: Data[];
  };
  'data-table:download': TableEvent & {
    fileName: string;
    multiTableNames?: string[];
    additionalTexts?: (string | string[])[];
  };
  'data-table:select-all-record': TableEvent;
  'data-table:update-total-record': TableEvent & {
    total: number;
  };
  'data-table:update-selected-data': TableEvent & {
    data?: Data[];
  };
  'data-table:clear-selected-data': TableEvent;
  'data-table:import-excel-to-json': TableEvent & {
    data: Data[];
  };
  'work-calendar:reset-month': unknown;
  'work-calendar:reset-year': unknown;
  'toast:add': ToastMessageOptions;
  'tree:update-tree-nodes': unknown;
  'tree:tree-updated': unknown;
  'tree:selection-changed': {
    keys: string;
  };
  'overlay:show': {
    overlayId: number;
  };
};

export type Events<CustomEvents = undefined> = CustomEvents extends undefined
  ? PredefinedEvents
  : CustomEvents & PredefinedEvents;

const eventBus = mitt<Events>();

export const extendEventBus = <T>(): Emitter<Events<T>> => {
  return eventBus as unknown as Emitter<Events<T>>;
};

export default eventBus;
